import Flickity from 'flickity';

export default {
  init($element) {
  },
  finalize($element) {
    if ($element.find('.stories-carousel')) {
      const storiesCarousel = new Flickity($element.find('.stories-carousel').get()[0], {
        // adaptiveHeight: true,
        autoPlay: false,
        prevNextButtons: false,
        pageDots: false,
        contain: true,
        on: {
          ready: function() {
            window.dispatchEvent(new Event('resize')); // Quickfix for sizing issue
          },
        },
      });

      // Set the width of the scroller based on the number of carousel items
      const carouselItems = $element.find('.stories-carousel .carousel-cell').length;
      const carouselPercentage = (1 / carouselItems) * 100;
      $element.find('.progress-slider-wrap .progress-slider-inner').css({ width: carouselPercentage.toString() + '%' });

      // Set the scroller position
      storiesCarousel.on('change', function(i) {
        var currentIndex = i;

        if ($(window).outerWidth() >= 992) {
          // First pressing the next button does not move the slider because apparently 0 == 1 :)
          if (currentIndex == 1) {
            currentIndex = 0;
          }

          // Snap to prevent weird thing where continuously scrolling right at the end
          // of the carousel causes the scroller to switch between carouselItems and carouselItems - 1
          if (currentIndex == carouselItems - 2) {
            currentIndex = carouselItems - 1;
          }
        }

        const scrollPosition = carouselPercentage * currentIndex;
        $element.find('.progress-slider-wrap .progress-slider-inner').css({ left: scrollPosition.toString() + '%' });
      });

      // Scroll buttons
      $element.find('.progress-slide-arrow-prev').on('click', function() {
        storiesCarousel.previous();

        if ($(window).outerWidth() >= 992) {
          // Again another funny workaround
          if (storiesCarousel.selectedIndex == carouselItems - 2) {
            storiesCarousel.previous();
          }
        }
      });
      
      $element.find('.progress-slide-arrow-next').on('click', function(i) {
        storiesCarousel.next();

        if ($(window).outerWidth() >= 992) {
          // Again another funny workaround
          if (storiesCarousel.selectedIndex == 1) {
            storiesCarousel.next();
          }
        }
      });

      storiesCarousel.on('change', function(i) {
        if (i == 0) {
          $element.find('.progress-slide-arrow-prev').addClass('disabled');
        } else {
          $element.find('.progress-slide-arrow-prev').removeClass('disabled');
        }

        if (i + 1 >= storiesCarousel.slides.length) {
          $element.find('.progress-slide-arrow-next').addClass('disabled');
        } else {
          $element.find('.progress-slide-arrow-next').removeClass('disabled');
        }
      });
    }
  },
}


// WEBPACK FOOTER //
// ./scripts/partials/home/storiesScroller.js